import alt from '../alt';

class ZopimActions {
  onlineStatusUpdated(status) {
    return status;
  }
}

export default alt.createActions(ZopimActions);



// WEBPACK FOOTER //
// ./javascripts/components/zopim/zopim_actions.js